import React from "react";
import { ActionIcon, Menu } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { IconLanguage } from "@tabler/icons-react";

import { appLanguages } from "@lib/appLanguages";

export default function LanguagePicker() {
  const { i18n } = useTranslation();

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem("mixer_app_language", language);
  };

  const currentLanguage = appLanguages.find(
    (language) => language.language === i18n.language
  );

  return (
    <Menu>
      <Menu.Target>
        <ActionIcon size={40} variant="light" radius="xl" onClick={() => true}>
          {currentLanguage ? currentLanguage.flag : <IconLanguage size={20} />}
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {appLanguages.map((language) => (
          <LanguageItem
            key={language.language}
            label={language.label}
            value={language.language}
            onClick={() => handleLanguageChange(language.language)}
          />
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}

const LanguageItem = ({ label, onClick }) => {
  const { i18n } = useTranslation();

  return <Menu.Item onClick={onClick}>{label}</Menu.Item>;
};
